/* ============================================================
   Ansicht anpassen (Barrierefreiheit) · v2 · Claude, 2026-09-29
   Speichert die Auswahl in localStorage ('bek-a11y'), setzt Klassen auf <html>,
   steuert das Panel (snippets/bek-a11y-panel.liquid) und die Einstiege ([data-bek-a11y-open]).
   Ereignis 'bek:reduce-motion' {on} nur bei echter Änderung (Vertrag für Slider/Videos).
   Öffentliche API: window.BEKA11y = { open, close, get, set, reset }
   Geschrieben wird nur nach einer Nutzeraktion im Panel.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'bek-a11y';
  var root = document.documentElement;
  var BOOL_KEYS = ['motion', 'contrast', 'spacing', 'font', 'links', 'calm', 'targets', 'ruler'];
  var CLASS = { motion: 'bek-reduce-motion', contrast: 'bek-contrast', spacing: 'bek-spacing', font: 'bek-font', links: 'bek-links', calm: 'bek-calm', targets: 'bek-targets', ruler: 'bek-ruler' };
  var LABEL = { motion: 'Bewegung stoppen', contrast: 'Kontrast erhöhen', spacing: 'Mehr Abstand', font: 'Lesefreundliche Schrift', links: 'Links unterstreichen', calm: 'Ruhige Ansicht', targets: 'Größere Klickflächen', ruler: 'Lesemaske' };
  var TEXT_LABEL = ['Standard', 'Größer', 'Am größten'];
  var THEME_LABEL = { light: 'Hell', dark: 'Dunkel', system: 'Automatisch' };
  var DEVICE_KEYS = ['motion', 'contrast'];

  function mq(q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; }
  function onMq(q, fn) { if (q.addEventListener) q.addEventListener('change', fn); else if (q.addListener) q.addListener(fn); }
  var mqMotion = mq('(prefers-reduced-motion: reduce)');
  var mqContrast = mq('(prefers-contrast: more)');
  var mqForced = mq('(forced-colors: active)');

  /* Gleiche Regeln wie im Frühstart (snippets/bek-a11y-head.liquid) */
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!s || typeof s !== 'object' || Array.isArray(s)) s = {};
    delete s.profile;
    if (!s.v && Object.keys(s).length) { /* v1 (28.09.) → v2 */
      if (s.text === 115) s.text = 1; else if (s.text === 130) s.text = 2; else delete s.text;
      if (s.readable) s.font = true;
      delete s.readable; delete s.focus;
    }
    s.v = 2;
    return s;
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  var state = load();

  function device(k) { return k === 'motion' ? !!mqMotion.matches : !!(mqContrast.matches || mqForced.matches); }
  function isOn(k) {
    if (DEVICE_KEYS.indexOf(k) > -1) return state[k] === undefined ? device(k) : !!state[k];
    return !!state[k];
  }
  function fromDevice(k) { return DEVICE_KEYS.indexOf(k) > -1 && state[k] === undefined && device(k); }
  /* Eine Anpassung liegt nur vor, wenn etwas vom Standard (bzw. von der Geräteeinstellung) abweicht */
  function isCustom() {
    if (state.text === 1 || state.text === 2) return true;
    for (var i = 0; i < BOOL_KEYS.length; i++) {
      var k = BOOL_KEYS[i];
      if (DEVICE_KEYS.indexOf(k) > -1) { if (state[k] !== undefined && !!state[k] !== device(k)) return true; }
      else if (state[k]) return true;
    }
    return false;
  }
  /* ---------- Anwenden ---------- */
  function applyAll(notify) {
    BOOL_KEYS.forEach(function (k) { if (k !== 'motion') root.classList.toggle(CLASS[k], isOn(k)); });
    if (state.text === 1 || state.text === 2) root.setAttribute('data-bek-text', String(state.text)); else root.removeAttribute('data-bek-text');
    root.classList.toggle('bek-custom', isCustom());
    var m = isOn('motion');
    if (root.classList.contains(CLASS.motion) !== m) applyMotion(m, !!notify);
    contrastPass.toggle(isOn('contrast'));
    ruler.toggle(isOn('ruler'));
  }

  /* ---------- Bewegung ---------- */
  var pausedByUs = [];
  var lastGesture = { t: 0, el: null };
  document.addEventListener('pointerdown', function (e) { lastGesture = { t: Date.now(), el: e.target }; }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') lastGesture = { t: Date.now(), el: e.target }; }, true);
  function userIntended(v) {
    if (Date.now() - lastGesture.t > 1200 || !lastGesture.el || !lastGesture.el.closest) return false;
    var scope = v.closest('.shopify-section, section, [role="dialog"], .modal') || v.parentNode;
    return lastGesture.el === v || (scope && scope.contains(lastGesture.el));
  }
  function flickities(fn) {
    if (!window.Flickity || !Flickity.data) return;
    document.querySelectorAll('.flickity-enabled').forEach(function (el) {
      var f = Flickity.data(el);
      if (f && f.options && f.options.autoPlay) { try { fn(f); } catch (e) {} }
    });
  }
  function applyMotion(on, notify) {
    root.classList.toggle(CLASS.motion, on);
    if (on) {
      document.querySelectorAll('video').forEach(function (v) {
        if (!v.paused && (v.autoplay || v.loop || v.muted) && !v.controls) { v.pause(); if (pausedByUs.indexOf(v) < 0) pausedByUs.push(v); }
      });
      flickities(function (f) { f.stopPlayer(); });
    } else {
      pausedByUs.forEach(function (v) { if (v.isConnected && v.paused && !v.hasAttribute('data-bek-user-paused')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
      pausedByUs = [];
      flickities(function (f) { f.playPlayer(); });
    }
    if (notify) document.dispatchEvent(new CustomEvent('bek:reduce-motion', { detail: { on: on } }));
  }
  /* Später startende Autoplay-Videos ohne eigene Steuerung anhalten; bewusstes Abspielen erlauben.
     Erst bei 'playing' eingreifen, damit ein play()-Promise des Themes nicht abbricht (sonst blendet es native Controls ein).
     Videos mit eigenem Pause-Knopf (.bek-media-ctl) regeln das selbst. */
  document.addEventListener('playing', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !root.classList.contains(CLASS.motion)) return;
    if (v.controls || userIntended(v)) return;
    if (v.id && document.querySelector('.bek-media-ctl[aria-controls="' + v.id + '"]')) return;
    if (v.autoplay || v.loop || v.muted) { v.pause(); if (pausedByUs.indexOf(v) < 0) pausedByUs.push(v); }
  }, true);
  onMq(mqMotion, function () { if (state.motion === undefined) { applyAll(true); ui.sync(); } });
  [mqContrast, mqForced].forEach(function (q) { onMq(q, function () { if (state.contrast === undefined) { applyAll(true); ui.sync(); } }); });

  /* ---------- Kontrast: Einzelfälle korrigieren (nur bei aktivem Kontrastmodus) ----------
     Prüft sichtbaren Text gegen den tatsächlichen Hintergrund (inkl. Verläufe) und setzt bei zu wenig Kontrast
     dunkle (#111) oder helle (#fff) Schrift – je nachdem, was mehr Kontrast ergibt. Text über Bildern/Videos bleibt unangetastet.
     Neuberechnung je Element im selben Task (Klasse lösen, messen, setzen): kein Aufblitzen alter Farben. */
  var contrastPass = (function () {
    var active = false, obs = null, timer = null, pendingFull = false, pendingScopes = [], bgCache = null, done = new WeakSet();
    var DARK = { r: 17, g: 17, b: 17, a: 1 }, LIGHT = { r: 255, g: 255, b: 255, a: 1 };
    var now = (window.performance && performance.now) ? function () { return performance.now(); } : function () { return Date.now(); };
    function parse(str) {
      if (!str) return null;
      var m = str.match(/rgba?\(([^)]+)\)/);
      if (m) {
        var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
        return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
      }
      m = str.match(/color\(srgb\s+([^)]+)\)/);
      if (m) {
        var q = m[1].split(/[\s\/]+/).filter(Boolean).map(parseFloat);
        return { r: q[0] * 255, g: q[1] * 255, b: q[2] * 255, a: q.length > 3 ? q[3] : 1 };
      }
      return null;
    }
    function lin(c) { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    function lum(c) { return 0.2126 * lin(c.r) + 0.7152 * lin(c.g) + 0.0722 * lin(c.b); }
    function ratio(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
    function blend(fg, bg) { var a = fg.a == null ? 1 : fg.a; return { r: fg.r * a + bg.r * (1 - a), g: fg.g * a + bg.g * (1 - a), b: fg.b * a + bg.b * (1 - a), a: 1 }; }
    function gradientColors(bi) {
      var out = [], re = /rgba?\([^)]+\)|color\(srgb[^)]+\)/g, m;
      while ((m = re.exec(bi))) { var c = parse(m[0]); if (c && c.a >= 0.5) out.push(c); }
      return out;
    }
    var MEDIA = ':scope > img, :scope > picture, :scope > video, :scope > iframe, :scope > canvas, :scope > [class*="video"], :scope > [class*="image"], :scope > [class*="media"], :scope > [class*="hero__"], :scope > [class*="slide"]';
    function bgFor(el) {
      var chain = [], node = el, found = null;
      while (node && node.nodeType === 1) {
        if (bgCache.has(node)) { found = bgCache.get(node); break; }
        chain.push(node);
        var cs = getComputedStyle(node);
        var bi = cs.backgroundImage;
        if (bi && bi !== 'none') {
          if (/url\(/.test(bi)) { found = 'media'; break; }
          var g = gradientColors(bi);
          if (g.length) { found = g; break; }
        }
        var bc = parse(cs.backgroundColor);
        if (bc && bc.a >= 0.6) { found = [bc]; break; }
        if (node !== el) {
          try {
            var med = node.querySelector(MEDIA);
            if (med && !med.contains(el)) { var ms = getComputedStyle(med); if (ms.position === 'absolute' || ms.position === 'fixed' || ms.objectFit === 'cover') { found = 'media'; break; } }
          } catch (e) {}
        }
        node = node.parentElement;
      }
      if (!found) found = [root.classList.contains('theme-dark') ? { r: 18, g: 18, b: 18, a: 1 } : { r: 255, g: 255, b: 255, a: 1 }];
      chain.forEach(function (n) { bgCache.set(n, found); });
      return found;
    }
    function hasOwnText(el) {
      for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && /\S/.test(n.nodeValue)) return true;
      return false;
    }
    function verdict(el) {
      var cs = getComputedStyle(el);
      if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return null;
      var bg = bgFor(el);
      if (bg === 'media') return null;
      var fg = parse(cs.color); if (!fg) return null;
      var size = parseFloat(cs.fontSize) || 16, bold = parseInt(cs.fontWeight, 10) >= 700;
      /* Graue Schrift: AAA (7:1, groß 4,5:1). Farbige Schrift (z. B. Rot für „Sparen“) bleibt farbig, solange sie AA erreicht. */
      var mx = Math.max(fg.r, fg.g, fg.b), mn = Math.min(fg.r, fg.g, fg.b);
      var colored = mx > 0 && (mx - mn) / mx > 0.35;
      var large = size >= 24 || (size >= 18.66 && bold);
      var need = colored ? (large ? 3 : 4.5) : (large ? 4.5 : 7);
      var worst = Infinity, worstDark = Infinity, worstLight = Infinity;
      bg.forEach(function (b) {
        worst = Math.min(worst, ratio(blend(fg, b), b));
        worstDark = Math.min(worstDark, ratio(DARK, b));
        worstLight = Math.min(worstLight, ratio(LIGHT, b));
      });
      if (worst >= need) return null;
      return worstDark >= worstLight ? 'bek-ct-dark' : 'bek-ct-light';
    }
    function check(el) {
      if (done.has(el)) return;
      if (el.closest('.bek-a11y, svg, script, style, noscript, template, iframe')) { done.add(el); return; }
      if (!hasOwnText(el) && !/^(INPUT|SELECT|TEXTAREA|BUTTON)$/.test(el.tagName)) return;
      if (!el.getClientRects().length) return;
      done.add(el);
      var had = el.classList.contains('bek-ct-dark') ? 'bek-ct-dark' : el.classList.contains('bek-ct-light') ? 'bek-ct-light' : null;
      if (had) el.classList.remove(had);
      var v = verdict(el);
      if (v) el.classList.add(v);
    }
    function collect(scopes) {
      var list = [];
      scopes.forEach(function (s) {
        if (!s || !s.isConnected || s.nodeType !== 1) return;
        list.push(s);
        var all = s.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) list.push(all[i]);
      });
      return list;
    }
    function run(scopes) {
      if (!active) return;
      bgCache = new Map();
      var list = collect(scopes || [document.body]);
      var i = 0;
      (function chunk() {
        if (!active) return;
        var t0 = now();
        while (i < list.length && now() - t0 < 8) { try { check(list[i]); } catch (e) {} i++; }
        if (i < list.length) (window.requestAnimationFrame || setTimeout)(chunk);
      })();
    }
    function clearAll() { document.querySelectorAll('.bek-ct-dark, .bek-ct-light').forEach(function (el) { el.classList.remove('bek-ct-dark', 'bek-ct-light'); }); }
    function schedule(full, scope) {
      if (full) pendingFull = true; else if (scope) pendingScopes.push(scope);
      clearTimeout(timer);
      timer = setTimeout(function () {
        var f = pendingFull, sc = pendingScopes;
        pendingFull = false; pendingScopes = [];
        if (f) { done = new WeakSet(); run(); }
        else if (sc.length) run(sc);
      }, pendingFull ? 60 : 350);
    }
    return {
      toggle: function (on) {
        if (on === active) return;
        active = on;
        if (on) {
          done = new WeakSet();
          (window.requestAnimationFrame || setTimeout)(function () { if (active && document.body) run(); });
          if ('MutationObserver' in window && document.body) {
            obs = new MutationObserver(function (muts) {
              for (var i = 0; i < muts.length; i++) {
                var t = muts[i].target;
                if (!t || t.nodeType !== 1 || (t.closest && t.closest('.bek-a11y'))) continue;
                if (muts[i].addedNodes.length) schedule(false, t);
              }
            });
            obs.observe(document.body, { childList: true, subtree: true });
          }
        } else {
          if (obs) { obs.disconnect(); obs = null; }
          clearTimeout(timer); pendingFull = false; pendingScopes = [];
          clearAll(); done = new WeakSet();
        }
      },
      refresh: function () { if (active) schedule(true); }
    };
  })();

  /* ---------- Lesemaske ---------- */
  var ruler = (function () {
    var el = null, on = false, raf = 0, y = window.innerHeight * 0.4;
    function h() { var fs = parseFloat(getComputedStyle(document.body).fontSize) || 16; return Math.max(72, Math.round(fs * 1.7 * 2.6)); }
    function place() { raf = 0; if (!el) return; var hh = h(); el.style.setProperty('--bk-mask-h', hh + 'px'); el.style.setProperty('--bk-mask-y', Math.max(0, y - hh / 2) + 'px'); }
    function move(e) { y = e.clientY; if (!raf) raf = requestAnimationFrame(place); }
    function focus(e) {
      var t = e.target; if (!t || !t.getBoundingClientRect || (t.closest && t.closest('.bek-a11y'))) return;
      var r = t.getBoundingClientRect(); y = r.top + r.height / 2; if (!raf) raf = requestAnimationFrame(place);
    }
    return {
      toggle: function (want) {
        want = !!want && mq('(pointer: fine)').matches;
        if (want === on) return;
        el = el || document.querySelector('[data-bek-a11y-mask]');
        if (!el) return;
        on = want;
        el.hidden = !on;
        if (on) { place(); window.addEventListener('pointermove', move, { passive: true }); document.addEventListener('focusin', focus); }
        else { window.removeEventListener('pointermove', move); document.removeEventListener('focusin', focus); }
      }
    };
  })();

  /* ---------- Panel ---------- */
  var ui = { sync: function () {} };
  function initPanel() {
    var wrap = document.querySelector('[data-bek-a11y]');
    if (!wrap) return;
    var panel = wrap.querySelector('[data-bek-a11y-panel]');
    var title = panel.querySelector('.bek-a11y__title');
    var status = panel.querySelector('[data-bek-a11y-status]');
    var opts = panel.querySelectorAll('[data-bek-a11y-opt]');
    var sizes = panel.querySelectorAll('[data-bek-a11y-text]');
    var themes = panel.querySelectorAll('[data-bek-a11y-theme]');
    var resetBtn = panel.querySelector('[data-bek-a11y-reset]');
    var lastTrigger = null;   /* Ziel der Fokus-Rückgabe */
    var anchor = null;        /* Positionsanker */
    var pendingOpen = 0;

    function announce(msg) {
      if (!status) return;
      status.textContent = '';
      setTimeout(function () { status.textContent = msg; }, 60);
    }
    function sync() {
      opts.forEach(function (b) {
        var k = b.getAttribute('data-bek-a11y-opt');
        b.setAttribute('aria-checked', isOn(k) ? 'true' : 'false');
        var src = panel.querySelector('[data-bek-a11y-src="' + k + '"]');
        if (src) {
          var show = fromDevice(k);
          src.hidden = !show;
          var base = b.getAttribute('data-bek-desc') || b.getAttribute('aria-describedby') || '';
          if (!b.hasAttribute('data-bek-desc')) b.setAttribute('data-bek-desc', base);
          b.setAttribute('aria-describedby', show && src.id ? base + ' ' + src.id : base);
        }
      });
      var t = state.text || 0;
      sizes.forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-bek-a11y-text')) === t)); });
      var mode = window.BEKTheme ? window.BEKTheme.mode() : (root.classList.contains('theme-dark') ? 'dark' : 'light');
      themes.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-bek-a11y-theme') === mode)); });
      if (resetBtn) resetBtn.disabled = !isCustom();
      root.classList.toggle('bek-custom', isCustom());
    }
    ui.sync = sync;

    function visible(el) { return el && el.getClientRects().length ? el : null; }
    function triggers() { return document.querySelectorAll('[data-bek-a11y-open]'); }
    function expanders() { return document.querySelectorAll('[aria-controls="BekA11yPanel"]'); }
    function position(trigger) {
      panel.removeAttribute('data-anchor');
      panel.style.removeProperty('--bk-top'); panel.style.removeProperty('--bk-right');
      if (trigger && trigger.hasAttribute('data-bek-a11y-fab')) { panel.setAttribute('data-anchor', 'bottom-left'); return; }
      var vw = window.innerWidth, pw = Math.min(424, vw - 32);
      var r = trigger && !trigger.classList.contains('skip-link') && trigger.getBoundingClientRect ? trigger.getBoundingClientRect() : null;
      if (r && r.width && r.bottom > 0 && r.bottom < window.innerHeight * 0.5 && r.left > vw / 2) {
        var right = Math.max(16, Math.round(vw - r.right - 8));
        right = Math.min(right, Math.max(16, vw - pw - 16));
        panel.style.setProperty('--bk-top', Math.round(r.bottom + 10) + 'px');
        panel.style.setProperty('--bk-right', right + 'px');
      } else {
        var hdr = document.querySelector('.site-header');
        var hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
        panel.style.setProperty('--bk-top', Math.round(Math.max(16, Math.min(hb, 140)) + 12) + 'px');
      }
    }
    function open(trigger, returnTo) {
      clearTimeout(pendingOpen);
      anchor = trigger || null;
      lastTrigger = returnTo || trigger || null;
      position(anchor);
      panel.hidden = false;
      wrap.classList.add('is-open');
      expanders().forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      sync();
      try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); }
      document.addEventListener('keydown', onKey);
      document.addEventListener('pointerdown', onOutside, true);
      document.addEventListener('focusin', onFocusIn);
      window.addEventListener('resize', onResize);
    }
    function close(returnFocus) {
      if (panel.hidden) return;
      panel.hidden = true;
      wrap.classList.remove('is-open');
      expanders().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pointerdown', onOutside, true);
      document.removeEventListener('focusin', onFocusIn);
      window.removeEventListener('resize', onResize);
      if (returnFocus) {
        var target = visible(lastTrigger) || visible(document.querySelector('.js-drawer-open-nav')) || visible(document.querySelector('.bek-a11y-trigger--header'));
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
      }
    }
    function onKey(e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && (panel.contains(document.activeElement) || document.activeElement === document.body)) { e.preventDefault(); close(true); }
    }
    function onOutside(e) {
      if (panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-bek-a11y-open]')) return;
      close(false);
    }
    /* Nicht-modal: Verlässt der Tastaturfokus das Panel, schließt es (sonst verdeckt es den Fokus, WCAG 2.4.11) */
    function onFocusIn(e) {
      var t = e.target;
      if (!t || panel.contains(t) || t === document.body || (t.closest && t.closest('[data-bek-a11y-open]'))) return;
      close(false);
    }
    function onResize() { if (!panel.hidden) position(anchor); }

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-bek-a11y-open]');
      if (!t) return;
      e.preventDefault();
      if (!panel.hidden && (anchor === t || lastTrigger === t)) { close(true); return; }
      /* Aus dem Handy-Menü: erst den Drawer schließen (sonst schließt ihn das Theme beim ersten Tipp ins Panel
         und zieht den Fokus weg), dann öffnen; Fokus kehrt später zum Menü-Knopf zurück. */
      var drawer = t.closest('.drawer');
      if (drawer) {
        var closeBtn = drawer.querySelector('.js-drawer-close');
        var back = visible(document.querySelector('.js-drawer-open-nav'));
        if (closeBtn) closeBtn.click();
        clearTimeout(pendingOpen);
        pendingOpen = setTimeout(function () {
          if (root.classList.contains('js-drawer-open')) return; /* Menü wurde inzwischen wieder geöffnet */
          open(null, back);
        }, closeBtn ? 560 : 0);
        return;
      }
      open(t);
    });
    panel.querySelector('[data-bek-a11y-close]').addEventListener('click', function () { close(true); });

    function changed(msg) {
      save(); applyAll(true); sync();
      if (msg) announce(msg);
    }
    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-bek-a11y-opt');
        var next = !isOn(k);
        if (DEVICE_KEYS.indexOf(k) > -1) {
          /* Entspricht die Wahl der Geräteeinstellung, nichts speichern (dann folgt sie dem Gerät) */
          if (next === device(k)) delete state[k]; else state[k] = next;
        } else if (next) state[k] = true; else delete state[k];
        delete state.profile;
        changed(LABEL[k] + (next ? ' ein' : ' aus'));
      });
    });
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Number(b.getAttribute('data-bek-a11y-text'));
        if (v) state.text = v; else delete state.text;
        delete state.profile;
        changed('Textgröße ' + TEXT_LABEL[v]);
        window.dispatchEvent(new Event('resize'));
      });
    });
    themes.forEach(function (b) {
      b.addEventListener('click', function () {
        var m = b.getAttribute('data-bek-a11y-theme');
        if (window.BEKTheme) window.BEKTheme.set(m);
        else root.classList.toggle('theme-dark', m === 'dark');
        sync(); announce('Darstellung ' + THEME_LABEL[m]);
      });
    });
    if (resetBtn) resetBtn.addEventListener('click', function () {
      state = { v: 2 };
      changed('Alle Einstellungen zurückgesetzt');
      window.dispatchEvent(new Event('resize'));
      title.focus();
    });
    var lastDark = root.classList.contains('theme-dark');
    document.addEventListener('bek:theme', function (e) {
      sync();
      var d = !!(e && e.detail && e.detail.dark);
      if (d !== lastDark) { lastDark = d; contrastPass.refresh(); }
    });

    window.BEKA11y = {
      open: function () { open(null); }, close: function () { close(false); },
      get: function () { return JSON.parse(JSON.stringify(state)); },
      set: function (k, v) { if (v === undefined || v === null) delete state[k]; else state[k] = v; delete state.profile; changed(); },
      reset: function () { state = { v: 2 }; changed(); }
    };
    sync();
  }

  /* ---------- Warenkorb, Formulare, iframes ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-bek-cart-count-sr]').forEach(function (el) { el.textContent = n + ' Artikel'; });
  }
  document.addEventListener('cart:updated', function (e) {
    var c = e && e.detail && e.detail.cart;
    if (c && typeof c.item_count === 'number') setCartCount(c.item_count);
  });
  document.addEventListener('ajaxProduct:added', function () {
    var url = (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart + '.js' : '/cart.js';
    if (window.fetch) fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (c && typeof c.item_count === 'number') setCartCount(c.item_count); }).catch(function () {});
  });

  /* AGB-Häkchen im Warenkorb: Fehler als Text am Feld statt nur Browser-alert() (WCAG 3.3.1) */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"][data-terms-required="true"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    var box = form && form.querySelector('.cart__terms-checkbox');
    if (!box || box.checked) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var msg = (window.theme && theme.strings && theme.strings.cartTermsConfirmation) || 'Bitte stimmen Sie den AGB zu.';
    var err = form.querySelector('.cart__terms-error') || document.getElementById('CartTermsError');
    if (err) err.textContent = msg; else window.alert(msg);
    box.setAttribute('aria-invalid', 'true');
    box.focus();
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('cart__terms-checkbox') || !t.checked) return;
    t.removeAttribute('aria-invalid');
    var form = t.form || t.closest('form');
    var err = form && form.querySelector('.cart__terms-error');
    if (err) err.textContent = '';
  });

  /* iframes ohne title (z. B. YouTube aus dem Admin-Editor) bekommen einen Namen (WCAG 4.1.2) */
  function titleFrames(scope) {
    var h1 = document.querySelector('main h1');
    var base = h1 ? h1.textContent.trim().replace(/\s+/g, ' ') : '';
    var list = (scope && scope.tagName === 'IFRAME') ? [scope] : (scope || document).querySelectorAll('iframe:not([title]), iframe[title=""]');
    Array.prototype.forEach.call(list, function (f) {
      if (f.getAttribute('title')) return;
      var src = f.getAttribute('src') || f.getAttribute('data-src') || '';
      var kind = /youtu/.test(src) ? 'YouTube-Video' : /vimeo/.test(src) ? 'Vimeo-Video' : /google\.[a-z.]+\/maps|maps\.google/.test(src) ? 'Karte' : 'Eingebetteter Inhalt';
      f.setAttribute('title', base ? kind + ': ' + base : kind);
    });
  }

  function init() {
    applyAll(false);
    /* Beim Laden kein Ereignis senden (Vertrag §5); nur bereits laufende Videos anhalten */
    if (isOn('motion')) applyMotion(true, false);
    initPanel();
    titleFrames();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.tagName === 'IFRAME' || (n.querySelector && n.querySelector('iframe')))) titleFrames(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('load', function () { if (isOn('motion')) applyMotion(true, false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
